<div class="overlay" *ngIf="open">
  <div class="panel">
    <button class="btn btn-close close-button" (click)="close.emit()" aria-label="Close">
    </button>

    <div class="banner-lang-dropdown d-none d-lg-flex">
      <don-language-selector size="desktop" (languageChange)="changeLanguage($event)">
      </don-language-selector>
    </div>

    <div class="banner-lang-dropdown d-flex d-lg-none">
      <don-language-selector size="mobile" (languageChange)="changeLanguage($event)">
      </don-language-selector>
    </div>

    <div class="modal-content-grid">
      <section class="hero">
        <div class="hero-success">
          <div class="illustration-stage">
            <ng-content select="[illustration]"></ng-content>
          </div>

          <h1 class="title m-0">
            {{ title | translate }}
          </h1>
        </div>
        <div class="desc">
          <p class="m-0" *ngFor="let line of descriptionLines; let last = last" [class.desc-highlight]="last">
            {{ line | translate }}
          </p>
        </div>

        <div class="monthly-community-card" *ngIf="showMonthlyCta" [formGroup]="monthlyJoinForm">

          <div class="community-card-header">
            <div class="community-icon-shell">
              <img class="community-icon-img" src="assets/Image/icons-donate/modal/icon-community-purple.svg"
                alt="Community Icon" />
            </div>

            <div class="community-copy">
              <h2 class="community-card-title m-0">
                {{ communityTitle | translate }}
              </h2>

              <p class="community-card-subtitle m-0">
                {{ subtitle | translate }}
              </p>
            </div>
          </div>

          <p class="billing-cycle-note m-0" *ngIf="monthlyJoinForm.get('firstPaymentDate')?.value">
            {{ 'CAMPAIGN.Conversion.MonthlyCycleStartsOn' | translate }}
            <strong>{{ monthlyJoinForm.get('firstPaymentDate')?.value }}</strong>.
          </p>

          <div class="monthly-inputs">
            <div class="field-group">
              <label class="field-label">
                {{ 'CAMPAIGN.Conversion.FirstChargeLabel' | translate }}
              </label>

              <input #dateInput class="field-input" type="text" formControlName="firstPaymentDate"
                [placeholder]="'CAMPAIGN.Conversion.FirstChargePlaceholder' | translate" readonly />
            </div>

            <div class="field-group">
              <label class="field-label">
                {{ 'CAMPAIGN.Conversion.MonthlyAmountLabel' | translate }}
              </label>

              <div class="amount-input-shell">
                <span class="amount-prefix">$</span>

                <input class="field-input amount-input" type="number" min="5" step="5"
                  formControlName="unitAmountMajor" />

                <span class="amount-suffix">
                  USD
                </span>
              </div>
            </div>
          </div>

          <button class="cta" [disabled]="ctaDisabled || monthlyJoinForm.invalid" (click)="onJoinMonthlyClick()">
            {{ monthlyCtaLabel | translate }}
            <span class="cta-arrow">→</span>
          </button>
        </div>
      </section>

      <aside class="summary-slot">
        <ng-content select="[summary]"></ng-content>
      </aside>
    </div>

    <don-footer [org]="org"></don-footer>
  </div>
</div>